// Chart.js — registración tree-shaken para panels que sí lo usan
// (PageviewsPanel principalmente). El barrel import pulls ~140 KB; con
// estos imports explícitos baja a ~38 KB gz dentro de NFR6 (≤ 40 KB
// reserved budget para Chart.js, ≤ 250 KB gz total).
//
// El módulo NO instancia chart aquí — solo registra controllers y
// configura defaults. Cada panel que use Chart.js importa este
// módulo (side-effect) antes de crear su Chart.

import {
  Chart,
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Filler,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
  DoughnutController,
} from 'chart.js';

let _registered = false;

export function ensureChartRegistered() {
  if (_registered) return;
  Chart.register(
    LineController,
    BarController,
    DoughnutController,
    BarElement,
    ArcElement,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    TimeScale,
    Filler,
    Tooltip,
  );
  // Defaults globales — animaciones off (FR42 reduced-motion + CPU
  // budget); paleta toma los tokens via getComputedStyle al momento
  // de instanciar el chart en el componente padre.
  Chart.defaults.animation = false;
  Chart.defaults.responsive = true;
  Chart.defaults.maintainAspectRatio = false;
  // Legend NO está en el whitelist — Chart.js no la renderiza si no
  // se registra el plugin. No tocamos defaults.plugins.legend (no
  // existe sin el plugin); el efecto neto es el mismo: sin legend.
  if (Chart.defaults.plugins?.tooltip) {
    Chart.defaults.plugins.tooltip.enabled = true;
  }
  Chart.defaults.interaction = { intersect: false, mode: 'index' };
  _registered = true;
}

export function _resetForTests() { _registered = false; }
